import { phoneNumber, supportEmail } from '../../../configs/ContactConfig';

export default {
  workspace: {
    recommendedForYou: {
      title: 'Khuyến nghị cho bạn',
    },
    workspaces: {
      title: 'Work Spaces',
    },
  },
  limitComponentMessage: '%{componentName} đã tồn tại',
  quickAccessComponentTitle: 'Chức năng tắt',
  quickAccess: {
    Watchlist: 'Danh mục',
    MarketInDepth: 'Thị trường chuyên sâu',
    MarketCalendar: 'Lịch sự kiện',
    MoneyFlow: 'Xu hướng dòng tiền',
    TimeAndSales: 'Time & sales',
    PriceDepth: 'Chi tiết bước giá',
    PriceData: 'Thống kê giá',
    Charting: 'Biểu đồ kỹ thuật',
    News: 'Tin tổng hợp',
    FASnapshot: 'Báo cáo doanh nghiệp',
    FinancialAnalysis: 'Phân tích tài chính',
    Valuation: 'Mô hình định giá',
    ConsensusAnalysis: 'Phân tích Consensus',
    Ownership: 'Sở hữu và GD nội bộ',
  },
  openWidget: 'Mở Widget',
  noMatchedStock: 'Không có cổ phiếu tương thích',
  addToHeadLine: 'Thêm vào tiêu đề',
  createWorkspace: 'Tạo Work Spaces',

  tooltipSideBar: {
    SAVE_CURRENT_WORKSPACE: 'Lưu Work Spaces hiện tại',
    REFRESH_WORKSPACE: 'Tải lại Work Spaces',
    DOWNLOAD_EXCEL_FORMAT: 'Tải xuống file Excel',
    GENERAL_SETTING: 'Cài Đặt Chung',
    OPEN_WORKSPACE: 'Mở Workspace',
    OPEN_A_COMPONENT: 'Mở chức năng',
  },

  notComeOut: {
    title: 'Chức năng hiện đang trong giai đoạn phát triển',
    message: 'Chúng tôi sẽ có thông báo khi hoàn thành. Vui lòng thử lại sau.',
  },

  logout: {
    title: 'Xác nhận đăng xuất',
    message: 'Bạn có chắc chắn muốn đăng xuất từ FiinTrade',
  },
  anotherLogin: 'Đăng nhập trên thiết bị khác',
  anotherLoginLineMessage: `Ai đó đã sử dụng tài khoản của bạn để đăng nhập trên thiết bị khác. Nếu không phải là bạn , đổi ngay mật khẩu đăng nhập để bảo vệ tài khoản <div style="margin-top: 10px"/>
    Liên hệ tổng đài CSKH
    <a href="tel:${phoneNumber}"><span style="color: #60bef1;">${phoneNumber}</span></a>
    hoặc email về
    <a href="mailto:${supportEmail}"><span style="color: #60bef1;">${supportEmail}</span></a>
    để được trợ giúp khi cần thiết
  `,
  sessionTimeout: 'Hết phiên đăng nhập',
  sessionTimeoutMessage: `
    Vì tính bảo mật thông tin, các tài khoản sẽ được đăng xuất sau mỗi 8 tiếng. <div style="margin-top: 10px"/>
    tài khoản của bạn sẽ tự động về giao diện đăng nhập sau %{seconds} giây
  `,
  expireTextLineOne:
    'Tài khoản của bạn đã hết thời gian đăng ký sử dụng. Vui lòng vào phần thông tin cá nhân để gia hạn tài khoản.',
  expireTextLineTwo: ` Liên hệ tổng đài CSKH
    <a href="tel:${phoneNumber}"><span style="color: #60bef1;">${phoneNumber}</span></a>
    hoặc email về
    <a href="mailto:${supportEmail}"><span style="color: #60bef1;">${supportEmail}</span></a>
    để được trợ giúp khi cần thiết`,

  timeoutAPI: 'Không tải được Dữ liệu.',
  timeoutAPIMessage: `Vui lòng đợi trong giây lát và thử lại.`,
  saveSettingMessage: 'Thay đổi thành công',
  changeLogs: 'Cập nhật mới',
  syncComponent: 'Đồng bộ chức năng',
  guest: {
    message: 'Bạn không có quyền truy cập vào chức năng này',
    contact: 'Liên hệ: ',
    please: 'Hãy ',
    toAccess: ' tài khoản để truy cập chức năng này!',
    hotline: 'Hotline: ',
    hasAccount: 'Bạn đã có tài khoản?',
    signUp: 'Đăng Ký',
    signIn: 'Đăng Nhập',
    upgrade: 'Nâng Cấp',
    guestFullText: 'Vui lòng đăng nhập tài khoản để truy cập chức năng này!',
    expiredFullText: 'Vui lòng nâng cấp tài khoản để truy cập chức năng này!',
  },
  continue: 'Tiếp tục',
};
